import React, { useState, useEffect }  from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { Menu } from 'antd';
import { SettingOutlined, PrinterOutlined, DashboardOutlined, DatabaseOutlined, BarChartOutlined } from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';
import { Link, useLocation } from "react-router-dom";
import { fetchServerVersion } from '../actions/serverVersion';

import { SUPPLIES_PATH, HISTORY_PATH, METERS_PATH, REPORTS_PATH, 
  SMTP_SERVER_PATH, HARDWARE_PATH, SERVERS_PATH, PRINTERS_PATH, 
  USERS_PATH, DOCUMENTS_PATH, USERS_GROUPS_PATH, MANAGE_PATH, 
  COMPUTERS_PATH, DB_SETTINGS_PATH, LICENSE_PATH, TASKS_PATH,
  DB_POLLING_PATH, PASSWORD_PATH, COMPUTERS_GROUPS_PATH, COST_PATH} from '../utils/constants';

import { IsAuthenticated } from '../utils/debug';


const LeftMenu = (props) => {

        const [state, setState] = useState({
          is_linux: false
        });

        const location = useLocation();
        
        const dispatch = useDispatch();
        let server_version = useSelector(state => state.serverVersion);
        if (!isServerVersionDefined(server_version))
        {
          if (IsAuthenticated())
          {
            dispatch(fetchServerVersion());
          }
        }

        function isServerVersionDefined(version)
        {
            return !(version === undefined || (Array.isArray(version) && version.length === 0) || (typeof version === 'object' && version === null))  
        }

        useEffect(() => {
          if (isServerVersionDefined(server_version))
          {
            setState({is_linux: server_version.os === 'linux'});
          }
        }, [server_version]);

        const items = [
          {
            key: 'sub1',
            label: <FormattedMessage id="LeftMenu.Submenu.general"/>,
            icon: <BarChartOutlined/>,
            children: [
              {
                key: SERVERS_PATH,
                label: <Link to={SERVERS_PATH}><FormattedMessage id="Servers"/></Link>,
              },
              {
                key: PRINTERS_PATH,
                label: <Link to={PRINTERS_PATH}><FormattedMessage id="Printers"/></Link>,
                icon: <PrinterOutlined/>,
                children: [
                  {
                    key: PRINTERS_PATH + MANAGE_PATH,
                    label: <Link to={PRINTERS_PATH + MANAGE_PATH}><FormattedMessage id="Manage"/></Link>,
                  },
                  /*
                  {
                    key: PRINTERS_PATH + COST_PATH,
                    label: <Link to={PRINTERS_PATH + COST_PATH}><FormattedMessage id="PrintingCost"/></Link>,
                  },
                  */
                ]
              },
              {
                key: USERS_PATH,
                label: <Link to={USERS_PATH}><FormattedMessage id="Users"/></Link>,
              },
              {
                key: COMPUTERS_PATH,
                label: <Link to={COMPUTERS_PATH}><FormattedMessage id="Computers"/></Link>,
              },
              {
                key: USERS_GROUPS_PATH,
                label: <Link to={USERS_GROUPS_PATH}><FormattedMessage id="Groups"/></Link>,
              },
              {
                key: COMPUTERS_GROUPS_PATH,
                label: <Link to={COMPUTERS_GROUPS_PATH}><FormattedMessage id="ComputersGroups"/></Link>,
              },
              {
                key: DOCUMENTS_PATH,
                label: <Link to={DOCUMENTS_PATH}><FormattedMessage id="Documents"/></Link>,
              },
            ]
          },
          {
            key: 'sub2',
            label: <FormattedMessage id="LeftMenu.SubMenu.devices"/>,
            icon: <DashboardOutlined/>,
            children: [
              {
                key: HARDWARE_PATH,
                label: <Link to={HARDWARE_PATH}><FormattedMessage id="LeftMenu.hardware"/></Link>,
              },
              {
                key: SUPPLIES_PATH,
                label: <Link to={SUPPLIES_PATH}><FormattedMessage id="LeftMenu.supplies"/></Link>,
              },
              {
                key: HISTORY_PATH,
                label: <Link to={HISTORY_PATH}><FormattedMessage id="LeftMenu.supplies_history"/></Link>,
              },
              {
                key: METERS_PATH,
                label: <Link to={METERS_PATH}><FormattedMessage id="LeftMenu.device_meters"/></Link>,
              },
            ]
          },
          {
            key: 'sub3',
            label: <FormattedMessage id="LeftMenu.SubMenu.settings"/>,
            icon: <SettingOutlined/>,
            children: [
              {
                key: LICENSE_PATH,
                label: <Link to={LICENSE_PATH}><FormattedMessage id="License"/></Link>,
              },
              ...(state.is_linux ? [{
                key: PASSWORD_PATH,
                label: <Link to={PASSWORD_PATH}><FormattedMessage id="Password"/></Link>,
              }] : []),
              {
                key: 'sub4',
                label: <FormattedMessage id="Database"/>,
                icon: <DatabaseOutlined/>,
                children: [
                  {
                    key: DB_SETTINGS_PATH,
                    label: <Link to={DB_SETTINGS_PATH}><FormattedMessage id="StorageSettings"/></Link>,
                  },
                  {
                    key: DB_POLLING_PATH,
                    label: <Link to={DB_POLLING_PATH}><FormattedMessage id="PollingRemoteDB"/></Link>,
                  },
                ]
              },
              {
                key: TASKS_PATH,
                label: <Link to={TASKS_PATH}><FormattedMessage id="Tasks"/></Link>,
              },
              {
                key: REPORTS_PATH,
                label: <Link to={REPORTS_PATH}><FormattedMessage id="LeftMenu.email_reports"/></Link>,
              },
              {
                key: SMTP_SERVER_PATH,
                label: <Link to={SMTP_SERVER_PATH}><FormattedMessage id="LeftMenu.SubMenu.smtp_server"/></Link>,
              },
            ]
          }
        ];

        return(
          <Menu theme="light" 
                defaultOpenKeys = {['sub1']} defaultSelectedKeys={[{SERVERS_PATH}]} mode="inline"
                selectedKeys={[location.pathname]}
                inlineIndent={24}
                items={items}
          >              
          </Menu>
        );
    }

export default LeftMenu;
